import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseMasterService } from '../../templates/services/base-master-service.template';
import { Core2Config } from '../../utils/core2-config';
import { PaymentChannelDenominationContainerModel } from '../../models/payment-channel/pgw-payment-channel-denomination.model';

@Injectable({
    providedIn: 'root'
})
export class PaymentChannelDenominationService extends BaseMasterService<PaymentChannelDenominationContainerModel> {

  constructor(protected readonly h: HttpClient) {
    super(Core2Config.TENANT_DOMAIN_URL_PREFIX + 'pgw/payment-denomination', h);
  }
}
